"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderList = void 0;
const rc_js_util_1 = require("rc-js-util");
/**
 * @public
 * Provides a grouping of entities and graphics components to update.
 */
class RenderList {
    constructor(updateGroupHooks) {
        this.updateGroupHooks = updateGroupHooks;
        this.groupings = [];
        this.uniqueEntities = [];
        this.currentGrouping = null;
        this.uniqueEntitiesSet = new Set();
    }
    addGrouping(grouping) {
        this.currentGrouping = [grouping, []];
        this.groupings.push(this.currentGrouping);
    }
    addEntity(entity) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(this.currentGrouping != null, "expected to find grouping");
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.currentGrouping[1].push(entity);
        this.uniqueEntitiesSet.add(entity);
    }
    build() {
        this.uniqueEntities = rc_js_util_1._Set.valuesToArray(this.uniqueEntitiesSet);
        this.uniqueEntitiesSet.clear();
    }
}
exports.RenderList = RenderList;
//# sourceMappingURL=render-list.js.map